import autocomplete from '@/components/autocomplete/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'delivery-zasilkovna-boxes',
  data() {
    return {
      cityList: [],
      filterCityList: [],
      selectedCity: null,
      selectedCityRef: null,
      selectedBranch: null,
      isTownsLoading: false,
      isDepartmensLoading: false,
    }
  },
  props: {
    cityError: {
      type: Boolean,
      default: true,
    },
    branchError: {
      type: Boolean,
      default: true,
    },
    selectedCountry: {
      type: Object,
      default: null,
    },
  },
  components: {
    autocomplete,
  },
  computed: {
    ...mapGetters({
      cities: 'zasilkovna/cities',
      branches: 'zasilkovna/branches',
    }),
  },
  watch: {
    selectedCountry(val) {
      if (val) {
        this.loadCitiesForCountry(val)
      }
    },
  },
  created() {
    if (this.selectedCountry) {
      this.loadCitiesForCountry(this.selectedCountry)
    }
  },
  methods: {
    ...mapMutations({
      saveAddress: 'order/SAVE_DELIVERY_ADDRESS',
    }),

    ...mapActions({
      fetchCity: 'zasilkovna/GET_BOX_CITY_LIST',
      fetchBranch: 'zasilkovna/GET_BOX_BRANCH_LIST',
      fetchBranchCountriesList: 'zasilkovna/GET_BOX_BRANCH_LIST',
    }),

    loadCitiesForCountry(country) {
      this.isTownsLoading = true
      this.selectedCity = null
      this.selectedBranch = null
      this.cityList = []
      this.filterCityList = []
      this.fetchCity({ country: country.alpha2Code.toLowerCase() })
        .then((response) => {
          this.cityList = response
          this.filterCityList = response
        })
        .finally(() => {
          this.isTownsLoading = false
        })
    },

    handleCityInput(e) {
      if (e.length < 3) {
        this.filterCityList = this.cityList.slice()
        return
      }
      this.filterCityList = this.cityList.filter((item) => item.name.toLowerCase().includes(e.toLowerCase()))
    },

    handleBranchInput(e) {
      if (e.length < 1) {
        this.fetchBranch({ city: this.selectedCity })
      }
      this.fetchBranch({ city: this.selectedCity, search: e })
    },

    async handleCitySelect(e) {
      this.selectedCityRef = e.id
      this.selectedCity = e.name
      this.isDepartmensLoading = true
      await this.fetchBranch({ city: this.selectedCity })
      this.isDepartmensLoading = false
      this.$refs.branchSelector.$el.querySelector('input').value = ''
      this.$emit('select-city', e)
      this.selectedBranch = ''
    },

    handleBranchSelect(e) {
      this.$emit('select-branch', e)
    },
  },
}
